<template>
  <div v-if="isSupport" class="menu">
    <li class="list-group-item" v-on:click="isMenuOpened = !isMenuOpened">
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/apri.svg'" alt="webapp_print" align="middle">
      <LabelFunMessage fcontId="0" msgkey="121" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>

    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <p class="app-message">
          <LabelFunMessage fcontId="0" msgkey="122" />
        </p>
        <p v-if="isJpTemplate" class="text-center">
          <AppCompatiblePrinters appName="photoplus_jp" />
        </p>
        <div>
          <div class="app_info">
            <img :src="app_root + '/assets/common/img/printlink/photoplus.ico'" />
            <p class="app_title">
              <LabelFunMessage fcontId="0" msgkey="85" />
            </p>
          </div>
          <p class="text-center modal-print-button">
            <a
              v-on:click="launchApp()"
              class="btn btn-info btn-lg"
              role="button"
            >
              <LabelFunMessage fcontId="0" msgkey="30" />&nbsp;&raquo;
            </a>
          </p>
        </div>

        <div>
          <p>
            <LabelFunMessage v-if="isSupportWwDesignpaper" fcontId="0" msgkey="151" />
            <LabelFunMessage v-else-if="isSupportPhotobook" fcontId="0" msgkey="174" />
            <LabelFunMessage v-else-if="isSupportNenga" />
            <LabelFunMessage v-else fcontId="0" msgkey="123" />
            <br>
            <LabelFunMessage fcontId="0" msgkey="124" />
          </p>
          <p class="text-center modal-print-button">
            <a
              v-on:click="trackGa4AppDownloadEvent()"
              v-bind:href="photoPlusDownloadLink"
              class="btn btn-default btn-lg"
              role="button"
              target="_blank"
            >
              <LabelFunMessage fcontId="0" msgkey="32" />&nbsp;&raquo;
            </a>
          </p>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";
import { LAUNCH_TYPE, CONTENT_TYPE, PAPER_SIZE, PAPER_TYPE } from "@/common/contentsinfo";
import { Collapse } from "uiv";

const APPURL = "com.epson.photoplus://1/"
const NOT_DEFINE_FCONT_ID = "designpaper_samplepage"

const APP_TOP_CATEGORY_ID = {
  designpaper: "LA_DP",
  photoLayout: "LA_PL",
  postcard: "LA_GC",
  nenga: "LA_NE",
  mochu: "LA_MO",
  greetingCards: "LA_VP",
  album: "LA_VP",
  photobook: "PB"
};

const GREETINGCARDS_SUB_CATEGORY_ID = "LA_GR"
const ALBUM_SUB_CATEGORY_ID = "LA_AL"
const PHOTOBOOK_SUB_CATEGORY_ID = "PB_LA"

const APP_MEDIA_SIZE_ID = {
  0: "A4",
  1: "LT",
  16: "HG",
};

const APP_FUNCTION_ID = {
  top: "top",
  select: "select",
  edit: "edit"
}

export default {
  name: "PrintMenuPhotoPlus",
  components: {
    LabelFunMessage,
    AppCompatiblePrinters,
    Collapse
  },
  props: {
    launchType: String, // select, print
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // designPaperの場合：xxx
    designId: String, // designPaperの場合：xx-xx
    mediaSizeId: String,
    mediaTypeId: String,
    fcontId: String,
  },
  data() {
    return {
      isMenuOpened: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapGetters(["isJpTemplate","isWwTemplate"]),
    ...mapState(["os"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
    isWindows: function () {
      return this.os == "ws";
    },
    isMac: function () {
      return this.os == "mi";
    },
    isSupport: function () {
      if (this.isPc) {
        switch (this.contentType) {
          case CONTENT_TYPE.nenga:
          case CONTENT_TYPE.postcard:
          case CONTENT_TYPE.mochu:
          case CONTENT_TYPE.photobook:
          case CONTENT_TYPE.album: 
            return this.isJpTemplate;
          case CONTENT_TYPE.designpaper:
          case CONTENT_TYPE.photoLayout:
          case CONTENT_TYPE.freeLayout:
          case CONTENT_TYPE.greetingCards:
            return true;
          case CONTENT_TYPE.designpaperPremiumCollection:
          case CONTENT_TYPE.createplusContents:
          case CONTENT_TYPE.creativeTop:
          default:
            return false;
        }
      }
      return false;
    },
    isSupportWwDesignpaper: function () {
      return this.isWwTemplate && (this.contentType == CONTENT_TYPE.designpaper);
    },
    isSupportPhotobook: function () {
      return this.isJpTemplate && (this.contentType == CONTENT_TYPE.photobook);
    },
    isSupportNenga: function () {
      return this.isJpTemplate && (this.contentType == CONTENT_TYPE.nenga);
    },
    photoPlusDownloadLink: function () {
      let query = [
        { key: "CTI", value: "104" },
        { key: "PRN", value: "Photo_Plus_Update" },
      ];
      if (this.isWindows) {
        query = query.concat([
          { key: "OSC", value: "W864" },
          { key: "WSI", value: "1" },
          { key: "OSV", value: "WIN64_6.2" },
          { key: "OATR", value: "9200_64_0.0_CLI" },
        ]);
      } else if (this.isMac) {
        query = query.concat([{ key: "OSV", value: "MACINTEL_10.13.6" }]);
      }
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `http://go.epson.com/redirect.aspx?` + pram;
    },
    functionId: function () {
      switch (this.launchType) {
        case LAUNCH_TYPE.select:
          return this.launchType;
        case LAUNCH_TYPE.print:
          return APP_FUNCTION_ID.edit;
        default:
          return APP_FUNCTION_ID.top;
      }
    },
    topCategoryId: function () {
      return APP_TOP_CATEGORY_ID[this.contentType];
    },
    subCategoryId: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.designpaper:
          return (
            APP_TOP_CATEGORY_ID[this.contentType] + this.categoryId.slice(1)
          );
        case CONTENT_TYPE.nenga:
          return this.categoryId;
        case CONTENT_TYPE.greetingCards:
          return GREETINGCARDS_SUB_CATEGORY_ID;
        case CONTENT_TYPE.album:
          return ALBUM_SUB_CATEGORY_ID;
        case CONTENT_TYPE.photobook:
          return PHOTOBOOK_SUB_CATEGORY_ID;
        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.designpaperPremiumCollection:
        case CONTENT_TYPE.creativeTop:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.mochu:
        default:
          return undefined;
      }
    },
    templateId: function () {
      if (this.designId == undefined) {
        return undefined
      }else {
        return `${this.topCategoryId}${this.designId}`;
      }
    },
    appPaperSizeId: function () {
      return APP_MEDIA_SIZE_ID[this.mediaSizeId];
    },
    articleId: function () {
      if (this.fcontId == undefined) {
        return NOT_DEFINE_FCONT_ID
      }else {
        return `${this.fcontId}_${this.functionId}`;
      }
    },
    selectOpenUrl: function () {
      let query;
      switch (this.contentType) {
        case CONTENT_TYPE.designpaper:
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.album:
        case CONTENT_TYPE.photobook:  
          query = [
            { key: "TCA", value: this.topCategoryId },
            { key: "SCA", value: this.subCategoryId },
            { key: "PID", value: this.articleId },
          ];
          return this.createPramUrl(query);

        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.mochu:
          query = [
            { key: "TCA", value: this.topCategoryId },
            { key: "PID", value: this.articleId },
          ];
          return this.createPramUrl(query);

        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.designpaperPremiumCollection:
        case CONTENT_TYPE.creativeTop:
        default:
          return `${APPURL}${APP_FUNCTION_ID.top}/`;
      }
    },
    printOpenUrl: function () {
       switch (this.launchType) {
        case LAUNCH_TYPE.print: {
          let query = [
            { key: "TID", value: this.templateId },
            { key: "SID", value: this.appPaperSizeId },
            { key: "PID", value: this.articleId },
          ];
          return this.createPramUrl(query);
        }
        case LAUNCH_TYPE.select:
        default:
          return `${APPURL}${APP_FUNCTION_ID.top}/`
       }
    },
    defaultMenuOpened: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.mochu:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.album:
        case CONTENT_TYPE.photobook:
        case CONTENT_TYPE.designpaper:
          return true;
        case CONTENT_TYPE.designpaperPremiumCollection:
        case CONTENT_TYPE.creativeTop:
        default:
          return false;
      }
    },
    isA4MattPaper: function () {
      return this.mediaSizeId == PAPER_SIZE.A4 && this.mediaTypeId == PAPER_TYPE.matte
    }
  },
  mounted: function () {
    this.isMenuOpened = this.defaultMenuOpened
  },
  methods: {
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Photo Plus",
        "location_id": "printButton",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    },
    trackGa4GoAppEvent: function() {
      this.$gtag.event("go_app", {
        "app_name": "Photo Plus",
        "article_no": this.fcontId,
        "print_type": this.launchType,
        "design_id": this.designId,
        "site_id": "gallery"
      })
    },
    launchApp: function () {
      this.trackGa4GoAppEvent()

      let openUrl = "";
      switch (this.launchType) {
        case LAUNCH_TYPE.select:
          openUrl = this.selectOpenUrl;
          break;
        case LAUNCH_TYPE.print:
          openUrl = this.printOpenUrl;
          break;
        default:
          openUrl = this.selectOpenUrl;
      }
      window.location = openUrl;
      this.$log.debug("url", openUrl);
    },
    createPramUrl: function (queryList) {
      const pram = queryList.map((q) => `${q.key}=${q.value}`).join("&");
      return `${APPURL}${this.functionId}/?${pram}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p.modal-print-button a {
  padding: 10px 5px;
  width: 100%;
  max-width: 300px;
}

.app_info {
  text-align: center;
  margin: 20px auto;
}

.app_info img {
  display: inline-block;
  max-width: 80px;
}

.app_title {
  margin-left: 10px;
  display: inline-block;
  vertical-align: center;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
}
</style>